/**
 * Clear any errors on n the given form element.
 *
 * @param {HTMLElement} element
 *   The form element to clear the message for
 * @param {string} messageSelector
 *   The selector to use to find the error message element
 */
export const errorClear = (element, messageSelector) => {
  const errorSpan = element.parentNode.querySelector(messageSelector)

  if (errorSpan) {
    errorSpan.innerHTML = ''
  }

  element.removeAttribute('aria-invalid')
}

/**
 * Show any errors on n the given form element.
 *
 * @param {HTMLButtonElement|HTMLFieldSetElement|HTMLInputElement|HTMLOutputElement|HTMLSelectElement|HTMLTextAreaElement} element
 *   The form element to set the message for
 * @param {string} messageSelector
 *   The selector to use to find the error message element
 * @param {string} message
 *   A custom message to display.
 *
 *   Mainly used for elements that don't easily support the validation API approach such as the DatePicker element
 */
export const errorShow = (element, messageSelector, message = null) => {
  const errorSpan = element.closest('.b-form-input').querySelector(messageSelector)

  if (errorSpan) {
    if (message) {
      element.setCustomValidity(message)
    }
    else if (element.validity.valueMissing && element.getAttribute('data-error-valuemissing-message')) {
      element.setCustomValidity(element.getAttribute('data-error-valuemissing-message'))
    }
    else if (element.validity.patternMismatch && element.getAttribute('data-error-patternmismatch-message')) {
      element.setCustomValidity(element.getAttribute('data-error-patternmismatch-message'))
    }
    else if (element.validity.rangeUnderflow && element.getAttribute('data-error-rangeunderflow-message')) {
      element.setCustomValidity(element.getAttribute('data-error-rangeunderflow-message'))
    }
    else if (element.validity.rangeOverflow && element.getAttribute('data-error-rangeoverflow-message')) {
      element.setCustomValidity(element.getAttribute('data-error-rangeoverflow-message'))
    }
    else if (element.validity.typeMismatch && element.getAttribute('data-error-typemismatch-message')) {
      element.setCustomValidity(element.getAttribute('data-error-typemismatch-message'))
    }
    else {
      element.setCustomValidity('')
    }

    errorSpan.innerHTML = element.validationMessage
    element.setAttribute('aria-invalid', 'true')
  }
}

/**
 * Show any errors on n the given form element.
 *
 * @param {HTMLButtonElement|HTMLFieldSetElement|HTMLInputElement|HTMLOutputElement|HTMLSelectElement|HTMLTextAreaElement} element
 *   The form element to set the message for
 * @param {string} messageSelector
 *   The selector to use to find the error message element
 * @param {string} message
 *   The message to show.
 */
export const errorShowCustom = (element, messageSelector, message) => {
  const errorSpan = element.parentNode.querySelector(messageSelector)

  if (errorSpan) {
    errorSpan.innerHTML = message
    element.setAttribute('aria-invalid', 'true')
  }
}
